import { connect } from 'react-redux'
import AgeGroupSelect from './groups-select'
import { fetchGroups } from '../../stores/groups/groups.actions'
import { withMe } from 'pobble-components/dist/pobble-user'
import {
  getGroupsFetchingStatus,
  getGroups,
  getUpdatableGroupsArray
} from '../../stores/groups/groups.selectors'
import { getSchoolId } from '../../stores/me/me.selectors'

const mapStateToProps = (state, { me }) => {
  const fetchingStatus = getGroupsFetchingStatus(state)
  return {
    schoolId: getSchoolId(me),
    fetching: fetchingStatus.pending,
    fetchingError: !fetchingStatus.pending && fetchingStatus.requestError,
    groups: getGroups(state),
    groupsArray: getUpdatableGroupsArray(state)
  }
}

const mapDispatchToProps = dispatch => ({ dispatch })

const mergeProps = (stateProps, { dispatch }, ownProps) => ({
  ...ownProps,
  ...stateProps,
  onMount: () => {
    if (!Object.keys(stateProps.groups).length)
      dispatch(fetchGroups(stateProps.schoolId))
  }
})

export default withMe(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
  )(AgeGroupSelect)
)
